export const REQUIRED_PROFILE_FIELDS: string[] = [
  'загрузить фото',
  'внести дату рождения',
  'заполнить СНИЛС'
];
